import { matchToDoc, scheduleConverter } from 'api/converters/ScheduleConverter';
import { teamConverter } from 'api/converters/TeamConverter';
import { ImageModel } from 'api/StorageAPI';
import { ActionCls, Emojis } from 'constants/constants';
import { collection, doc, getDocs, query, setDoc, updateDoc, writeBatch } from 'firebase/firestore';
import { sortNflTeamModelsByTeamId, sortScheduledMatchesByStartingDate } from 'helpers/SortingHelpers';
import { ScheduledMatch, TeamModel } from 'types/Schedule.types';
import { db } from '../firebase';

export const writeAllTeamsSmLogosToFB = async (images: ImageModel[]): Promise<void> => {
  const batch = writeBatch(db);

  images.forEach((img) => {
    const teamRef = doc(db, 'teams', img.name);
    batch.update(teamRef, { logoSmUrl: img.url });
  });

  console.log(`${Emojis.eyes} %c BATCH WRITING SM LOGOS %c teams`, ActionCls, '');

  return await batch.commit();
};

export type CallbackDFn<T> = (param: T) => void;

export const fetchAllTeams = async (successCb: CallbackDFn<TeamModel[]> = () => undefined): Promise<TeamModel[]> => {
  const collectionData = collection(db, 'teams').withConverter(teamConverter);
  const q = query(collectionData);

  const querySnapshot = await getDocs(q);
  const teams: TeamModel[] = [];
  querySnapshot.docs.forEach((doc) => {
    const docData: TeamModel = doc.data();
    teams.push({
      ...docData,
    });
  });

  teams.sort(sortNflTeamModelsByTeamId);

  successCb(teams);

  return teams;
};

export const fetchAllMatches = async (
  successCb: CallbackDFn<ScheduledMatch[]> = () => undefined
): Promise<ScheduledMatch[]> => {
  const collectionData = collection(db, 'schedule').withConverter(scheduleConverter);
  const q = query(collectionData);

  const querySnapshot = await getDocs(q);
  const matches: ScheduledMatch[] = [];
  querySnapshot.docs.forEach((doc) => {
    const match: ScheduledMatch = doc.data();
    matches.push({ ...match });
  });

  matches.sort(sortScheduledMatchesByStartingDate);

  successCb(matches);

  return matches;
};

export const postScheduledMatch = async (match: ScheduledMatch): Promise<ScheduledMatch> => {
  const scheduleMatchData = collection(db, 'schedule').withConverter(scheduleConverter);
  const docRef = doc(scheduleMatchData);

  const createdMatch: ScheduledMatch = { ...match, matchId: docRef.id };
  // Create new record with autogenerated id as messageId
  await setDoc(docRef, createdMatch);
  return createdMatch;
};

export const updateScheduledMatch = async (match: ScheduledMatch): Promise<void> => {
  const matchRef = doc(db, `schedule/${match.matchId}`).withConverter(scheduleConverter);
  return await updateDoc(matchRef, matchToDoc({ ...match }));
};

export const updateScheduledMatchScore = async (
  matchId: string,
  homeTeamPoints: number,
  awayTeamPoints: number,
  timeRemaining: number
): Promise<void> => {
  const matchRef = doc(db, `schedule/${matchId}`).withConverter(scheduleConverter);
  return await updateDoc(matchRef, { homeTeamPoints, awayTeamPoints, timeRemaining });
};
